var map = {
	"./match_24_1.jpg": 1929,
	"./match_24_10.jpg": 5749,
	"./match_24_2.jpg": 6782,
	"./match_24_3.jpg": 6939,
	"./match_24_4.jpg": 2056,
	"./match_24_5.jpg": 9669,
	"./match_24_6.jpg": 2442,
	"./match_24_7.jpg": 4375,
	"./match_24_8.jpg": 9220,
	"./match_24_9.jpg": 2817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2863;